export default __webpack_public_path__ + "static/media/laval10.59b36f59.jpg";